import dayjs from "dayjs";
import { api, giftApi, recordApi, transferApi, userApi } from "./baseApi";
import { formatTime } from "../utils/getDay";

export const getUserInfo = () => {
  return userApi.get("/getMemberInfo");
};

export const getVerifyCode = () => {
  return api.get("/verifyImg");
};

export const getCryptoRate = () => {
  return api.get("/getRate");
};

export const getDepositPaymentList = () => {
  return api.get("/payment/list");
};

export const getUserGameList = () => {
  return userApi.get("/getGameList");
};

export const getTransferWallet = ({
  platformUid,
  platformType,
  realPoint,
} = {}) => {
  return transferApi.get("/getTransferBalance", {
    params: {
      platformUid: platformUid,
      platformType: platformType,
      realPoint: realPoint || 0,
    },
  });
};

export const getGiftList = () => {
  return giftApi.get("/list");
};

// 函式名稱：getTransferWallet，它是一個匯出（export）的函式，可以在其他模塊中使用。
// 函式參數：這個函式接受一個包含 `platformUid` 和 `platformType` 的物件作為參數。
// 如果沒有提供這些參數，則預設為一個空物件（{}）。
// 函式主體：這個函式返回一個 API 請求，使用了 `userApi.get` 方法，請求的路徑為 "/getTransferBalance"。
// 在這個請求中，我們使用 `params` 屬性傳遞一個物件，包含 `platformUid` 和 `platformType` 的值。

export const getTransactionRecord = ({ action, params } = {}) => {
  const { str_date, end_date } = params;
  return recordApi.get(`/transaction/${action}`, {
    params: {
      str_date: `${formatTime(str_date)} 00:00:00`,
      end_date: `${formatTime(end_date)} 23:59:59`,
    },
  });
};

export const getBetRecord = ({ params }) => {
  const { str_date, end_date } = params;
  return api.get("/searchBet", {
    params: {
      str_date: `${formatTime(str_date)}`,
      end_date: `${formatTime(end_date)}`,
    },
  });
};

// export const getGiftList = ({ action, params } = {}) => {
//   const { str_date, end_date, time_type } = params;
//   return giftApi.get(`/gift/${action}`, {
//     params: {
//       str_date: `${formatTime(str_date)}`,
//       end_date: `${formatTime(end_date)}`,
//       time_type: time_type,
//     },
//   });
// };

export const getCommissionList = () => {
  return api.get("/commission");
}; //取傭金info

export const getUsedGiftList = ({ str_date, end_date, time_type } = {}) => {
  return giftApi.get("/own", {
    params: {
      str_date: `${formatTime(str_date)} 00:00:00`,
      end_date: `${formatTime(end_date)} 23:59:59`,
      time_type: time_type,
    },
  });
};
export const getFavoriteGameList = () => {
  return userApi.get("/getFavoriteGame");
}; //取最愛遊戲

export const getVipInfo = () => {
  return userApi.get("/getVipInfo");
};

export const getNewNotice = () => {
  return api.get("/notice/list");
};

export const getInboxList = () => {
  return api.get("/letter/list");
};

//取得玩家點擊過的遊戲
export const getUserGameClickList = () => {
  return userApi.get("/getUserGameClick");
};

export const getUserBalance = () => {
  return userApi.get("/singlewallet/get");
};

export const getMarquee = () => {
  return api.get("/marquees");
};

export const getBetHistory = ({ searchParams } = {}) => {
  const { str_date, end_date, platform, limit = 20, page = 1 } = searchParams;
  return api.get("/searchBetLog", {
    params: {
      str_date: `${formatTime(str_date)} 00:00:00`,
      end_date: `${formatTime(end_date)} 23:59:59`,
      platform: platform,
      limit: limit,
      page: page,
    },
  });
};

export const getBufferHistory = ({ searchParams } = {}) => {
  const { str_date, end_date, limit = 20, page = 1 } = searchParams;
  return api.get("/searchBufferWallet", {
    params: {
      str_date: `${formatTime(str_date)} 00:00:00`,
      end_date: `${formatTime(end_date)} 23:59:59`,
      limit: limit,
      page: page,
    },
  });
};

export const getTestBalance = () => {
  return userApi.get("/find-member");
};

export const postTestBalance = () => {
  return userApi.post("/testForBalanceDetect");
};

export const getShortLink = () => {
  return api.get("/invite/url");
};
